import { all } from "redux-saga/effects";
import { registerPHCOnboardingSagas } from "./PHCOnboarding/PHCOnboardingSaga";
import { PHCDashboardSaga } from "./PHCDashoard/PHCDashboardSaga";

function* registerPHCRootSaga() {
    yield all([
        registerPHCOnboardingSagas(),
        PHCDashboardSaga()
    ]);
}

export { registerPHCRootSaga };
